import ShowCaseHero from '@ulta/components/ShowCaseHero/ShowCaseHero';

export default ShowCaseHero;